<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" [config]="{backdrop: 'static'}"
     role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog call-dialog modal-dialog-centered modal-md">
    <div class="modal-content" style="background: #cbf1ff">
      <div class="modal-body p-5">
        <div class="text-center">
          <img userAvatar [usercode]="avatarUrl" class="call-avatar mb-3">
          <h3>{{fullname}}</h3>
          <h6 class="mb-3"> Đang gọi...</h6>
        </div>
        <ul class="d-flex justify-content-center">
          <li (click)="onAccessVideo()">
            <a class="icon-btn btn-success button-effect btn-xl is-animating" href="javascript:;" data-toggle="modal"
               data-target="#audiorcvcall"
               data-dismiss="modal">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-phone">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </a>
          </li>
          <li (click)="onDisposeVideo()" style="margin-left: 30px">
            <a class="icon-btn btn-danger button-effect btn-xl is-animating cancelcall" href="javascript:;"
               data-dismiss="modal">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-phone">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                </path>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
